import { AxiosResponse } from "axios";
import Config from "Config";
import axiosCalls from "global/util/axiosCalls";
import { getFilenameOutOfContentDisposition } from "global/util/REST/responseUtils";
import NoteRequestDTO from "./interface/NoteRequest";
import NoteSearchResultDTO from "./interface/NoteSearchResult";
import NoteDTO from "./mapping/NoteMapper";

const NoteService = {
  noteSaveOrUpdate: (notiz: NoteRequestDTO, callbackOnSuccess: Function) => {
    axiosCalls
      .sendJsonDataPost(Config.dataServiceUrl + "notizen/save", notiz)
      .then((response) => {
        callbackOnSuccess(NoteDTO.mapResponseToNoteDTO(response));
      })
      .catch((error) => {
        console.log(error);
        // @TODO fire error message
      });
  },
  noteSearch: (
    // in theory we need 'automatKey'
    option:
      | "automatKey"
      | "notizkopfKey"
      | "notizZeileKey"
      | "wiedervorlage"
      | "notizAlle"
      | "notizSuchmaske",
    value: string,
    callbackOnSuccess: (result: NoteSearchResultDTO) => void,
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendGet(Config.dataServiceUrl + "notizen/search/" + option + "/" + value)
      .then((response: AxiosResponse) => {
        callbackOnSuccess(NoteDTO.mapResponseToNoteSearchResultDTO(response));
      })
      .catch((error) => {
        if (callbackOnFail) callbackOnFail(error)
        // @TODO fire error message
      });
  },
  downloadNote: (
    notizTyp: string,
    automatKey: string,
    datumErfasst: string,
    dateiKey: string
  ) => {
    axiosCalls
      .sendGet(
        `${Config.dataServiceUrl}notizen/download/${notizTyp}/${automatKey}/${datumErfasst}/${dateiKey}`,
        {
          responseType: "blob", //im backend steht hier application/octet-stream
        }
      )
      .then((response: AxiosResponse) => {
        const link = document.createElement("a");
        let filename = getFilenameOutOfContentDisposition(
          response.headers["content-disposition"]
        );
        link.href = URL.createObjectURL(response.data);
        link.setAttribute("download", filename);
        link.hidden = true;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.log(error);
        // @TODO fire error message
      });
  },
};
export default NoteService;
